import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Skill } from "@app/models/rest/skill";

@Injectable({
  providedIn: "root"
})
export class SkillRestService extends HateoasResourceOperation<Skill> {
  constructor() {
    super(Skill);
  }
}
